import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Badge } from "antd";
import { CarOutlined, CommentOutlined, SettingOutlined, } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { ChannelType } from "@/types/chat";
import { replaceEmoji } from "@/utils/formatBotMessage";
import styles from "@/styles/ChannelItem.module.less";
const CHANNEL_ICONS = {
    [ChannelType.ROUTE]: _jsx(CarOutlined, {}),
    [ChannelType.SUPPORT]: _jsx(CommentOutlined, {}),
    [ChannelType.SYSTEM]: _jsx(SettingOutlined, {}),
};
const CHANNEL_COLORS = {
    [ChannelType.ROUTE]: "#1890ff",
    [ChannelType.SUPPORT]: "#52c41a",
    [ChannelType.SYSTEM]: "#8c8c8c",
};
function formatChannelTime(timestamp) {
    if (!timestamp)
        return "";
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();
    if (isToday) {
        return date.toLocaleTimeString("ru-RU", {
            hour: "2-digit",
            minute: "2-digit",
        });
    }
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear();
    if (isYesterday)
        return "Вчера";
    return date.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
    });
}
const ChannelItem = observer(({ channel, isActive, onClick }) => {
    const rootClass = `${styles.channelItem}${isActive ? ` ${styles["channelItem--active"]}` : ""}`;
    return (_jsxs("div", { className: rootClass, onClick: onClick, children: [_jsx(Avatar, { className: styles.avatar, icon: CHANNEL_ICONS[channel.type], style: { backgroundColor: CHANNEL_COLORS[channel.type] }, size: 40 }), _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.topRow, children: [_jsx("span", { className: styles.name, children: channel.displayName }), _jsx("span", { className: styles.time, children: formatChannelTime(channel.lastPostAt) })] }), _jsxs("div", { className: styles.bottomRow, children: [_jsx("span", { className: styles.preview, children: channel.lastMessagePreview
                                    ? replaceEmoji(channel.lastMessagePreview).replace(/\*\*/g, "")
                                    : "" }), _jsx("span", { className: styles.badge, children: _jsx(Badge, { count: channel.unreadCount, size: "small" }) })] })] })] }));
});
ChannelItem.displayName = "ChannelItem";
export default ChannelItem;
